<template>
  <div>
    <el-input
      @focus="handleClick"
      readonly
      v-model="skuIds"
      size="small"
      style="width: 280px"
      :placeholder="placeholder"
    ></el-input>
    <select-goods
      :isShow="goodsState"
      :moduleType="true"
      :skuSearch="venderType ? true : false"
      :selectGoods="returnSelectGoods"
      :selectGoodsSkuList="selectGoodsSkuList"
      :GoodsSkuIsflay="true"
      @close="selectGoodsChange"
    ></select-goods>
  </div>
</template>

<script>
import SelectGoods from "@/components/selectGoodsMonitor";

// import { mapState } from "vuex";

export default {
  name: "input-sku",
  components: {
    SelectGoods,
  },
  props: {
    sku: {
      type: String,
      default: "",
    },
    placeholder:{
      type: String,
      default: "请输入商品SKU",
    }
  },
  data() {
    return {
      goodsState: false,
      returnSelectGoods: [],
      selectGoodsSkuList: [],
    };
  },
  computed: {
    skuIds: {
      get: function(){return this.sku} ,
      set: function(val){
        this.$emit("update:sku", val)
      },
    },


    venderType(){
      return this.$store.getters.loginUserInfo.venderType
    }
    
  },
  created() {},
  mounted() {},
  methods: {
    selectGoodsChange(val, item) {
      this.goodsState = false;
      console.log(val,'val',item);
      // 
      
      if (val) {
        let valArr = [];
        this.returnSelectGoods = val;
        val.forEach((i) => {
          if (i.skuList != 0 && !this.venderType) {
            i.skuList.forEach((ele) => {
              if (ele.skuId) {
                valArr.push(ele.skuId);
              } else {
                valArr.push(ele);
              }
            });
          }else if(this.venderType){
            valArr.push(i.skuId);
          }
        });
        // 
        let itemArr = []
        if(!this.venderType){
          this.selectGoodsSkuList = item;
          itemArr = item.map((i) => i.skuId);
        }
        let skuIds = this.unique(itemArr, valArr).join(",");
        console.log('skuIds',skuIds)
        this.$emit("update:sku", skuIds)
      }
      
    },
    handleClick(){
      console.log('点击')
      this.goodsState = true;
    },
    unique(arr, arr1) {
      let list = arr.filter((item) => item);
      let listArr = list.map((item) => Number(item));
      let list1 = arr1.filter((item) => item);
      let listArr1 = list1.map((item) => Number(item));
      console.log(listArr, listArr1);
      return [...new Set([...listArr, ...listArr1])];
    },
  },
};
</script>
<style lang="scss" scoped></style>
